type TNetworkInformation = {
  effectiveType?: string
  downlink?: number
  rtt?: number
  saveData?: boolean
}

export const getConnectionInfo = (): Record<string, unknown> => {
  const { connection } = navigator as Navigator & {
    connection?: TNetworkInformation
  }

  if (!connection) return {}

  return {
    effectiveType: connection.effectiveType,
    downlink: connection.downlink,
    rtt: connection.rtt,
    saveData: connection.saveData,
  }
}
